import logo from "./logo.svg";
import "./App.css";
import { Route, Routes, useNavigate, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import { Amplify } from "aws-amplify";
import { fetchAuthSession, getCurrentUser } from "aws-amplify/auth";
import awsconfig from "./aws-exports";
import { useEffect, useState } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import DashBoard from "./pages/Dashboard";
import History from "./pages/History";
import SendPTCReportConfirm from "./pages/SendPTCReportConfirm";
import SendMonthlySnapshotReportConfirm from "./pages/SendMonthlySnapshotReportConfirm";

Amplify.configure(awsconfig);
function App() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const isLogin = async () => {
    try {
      const user = await getCurrentUser();

      if (user) {
        // navigate("/dashboard");
        setLoading(false);
      }
    } catch (error) {
      navigate("/login");
      setLoading(false);
      console.log(error);
    }
  };
  useEffect(() => {
    isLogin();
  }, []);

  if (loading) {
    return (
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<DashBoard />} />
      <Route path="/history" element={<History/>} />
      <Route path="/send-ptc-report/confirm" element={<SendPTCReportConfirm />} />
      <Route path="/send-monthly-snapshot/confirm" element={<SendMonthlySnapshotReportConfirm />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default App;
